export default {
  format () {
    console.log('date-format11');
  }
}